const settlementEdit = settlement => {
  const updateSettlement = { ...settlement };
  updateSettlement.issueDate = updateSettlement.issueDate
    ? updateSettlement.issueDate
        .split('-')
        .reverse()
        .join('-')
    : '';
  updateSettlement.endDate = updateSettlement.endDate
    ? updateSettlement.endDate
        .split('-')
        .reverse()
        .join('-')
    : '';
  updateSettlement.terminationReason = settlement.terminationReason?.value || '';
  updateSettlement.formEmployees = settlement.employees;
  return {
    settlementGroup: updateSettlement,
    employeesToDestroy: [],
    balancesToDestroy: [],
    balanceSettlementPairs: updateSettlement.balanceSettlementPairs
  };
};

const InitialValues = settlement => {
  if (settlement.id) return settlementEdit(settlement);

  return {
    settlementGroup: {
      filter: '',
      name: '',
      issueDate: '',
      endDate: '',
      ufValue: '',
      terminationReason: '',
      terminationReasonObject: '',
      employees: [],
      employeeIds: [],
      simulation: 'false',
      noticeMonth: 'false',
      causalJustification: false,
      justificationTerminationReason: '',
      balanceIds: []
    },
    selected: [],
    balances: [],
    employeesToDestroy: [],
    balancesToDestroy: [],
    balanceSettlementPairs: []
  };
};

export default InitialValues;
